import TableHead from "./Table/TableHead";
import useTable from "./Provider/useTable";
import TableRow from "./Table/TableRow";
import { Table, TBody } from "../components";
import { useNavigate } from "react-router-dom";
import TableContext from "./Provider/TableContext";
import DeleteModal from "./Table/DeleteModal";

function Suppliers() {
  const {
    limit,
    setLimit,
    docs,
    setDocs,
    isLoading,
    setIsLoading,
    pagination,
    setOrder,
    systemId,
    setSystemId,
    refetchDocs,
    showDeleteModal,
    setShowDeleteModal,
    handleDelete,
  } = useTable();

  const navigate = useNavigate();

  return (
    <>
      <TableContext.Provider
        value={{
          limit,
          setLimit,
          docs,
          setDocs,
          isLoading,
          setIsLoading,
          pagination,
          setOrder,
          systemId,
          setSystemId,
          refetchDocs,
          showDeleteModal,
          setShowDeleteModal,
          handleDelete,
        }}
      >
        <Table
          label="Suppliers"
          isLoading={isLoading}
          setIsLoading={setIsLoading}
          setDocs={setDocs}
          handleAdd={() => navigate("add")}
          handleRemoveFilters={() => {}}
          pagination={pagination}
        >
          <TableHead setOrder={setOrder} />
          <TBody>
            {docs.map((doc, i) => (
              <TableRow key={doc?.id || i} doc={doc} />
            ))}
          </TBody>
        </Table>
      </TableContext.Provider>

      {showDeleteModal && (
        <DeleteModal
          showDeleteModal={showDeleteModal}
          setShowDeleteModal={setShowDeleteModal}
          handleDelete={handleDelete}
          systemId={systemId}
        />
      )}
    </>
  );
}

export default Suppliers;
